module.exports = __webpack_public_path__ + "static/media/menu_dashboard_financeiro.af86839f.png";